import { useAppSelector } from "integrations/redux/hooks"
import { selectMapCommentsMap } from "features/entity-caching/map-comments/selectors"
import { MapCommentSort } from "plugins/Toolbox/MapComments/CommentSlice"
import { EVERYONE_CREATOR } from "./MapCommentFilterMenu"
import { MapComment } from "./groupCommentsByDay"

export const useFilteredMapComments = (
    comments: MapComment[] | undefined,
    { search, creatorId, sort }: { search: string; creatorId: string; sort: MapCommentSort }
) => {
    const mapCommentsById = useAppSelector(selectMapCommentsMap)

    const withMarker = (comments ?? []).filter(
        (comment) => comment.context.target === "map-pin" && mapCommentsById[comment.entityId]
    )
    const byDate = withMarker
        .filter((comment) => comment.comment.toLowerCase().includes(search.toLowerCase()))
        .filter((comment) => creatorId === EVERYONE_CREATOR || comment.createdBy === creatorId)
        .sort((a, b) => b.createdAt - a.createdAt)

    const filtered =
        sort === "unread"
            ? [
                  ...byDate.filter((comment) => comment.isUnread),
                  ...byDate.filter((comment) => !comment.isUnread),
              ]
            : byDate

    return { withMarker, filtered }
}
